"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var podcasts_graphql_client_1 = tslib_1.__importDefault(require("@wix/podcasts-graphql-client"));
var transformError_1 = tslib_1.__importDefault(require("./transformError"));
var queries_1 = require("./queries");
var PodcastFeedClient = /** @class */ (function () {
    function PodcastFeedClient(config) {
        this._client = new podcasts_graphql_client_1.default();
        this.init(config);
    }
    PodcastFeedClient.prototype.init = function (config) {
        this._client.init(config);
    };
    PodcastFeedClient.prototype.request = function (query, variables) {
        return this._client
            .request(query, variables)
            .catch(function (error) { return Promise.reject((0, transformError_1.default)(error)); });
    };
    PodcastFeedClient.prototype.checkUrl = function (variables, selection) {
        if (selection === void 0) { selection = queries_1.CHECK_URL_SELECTION; }
        return this.request((0, queries_1.createCheckUrlQuery)(selection), variables).then(function (data) { return data.checkUrl; });
    };
    PodcastFeedClient.prototype.getPodcast = function (variables, selection) {
        if (selection === void 0) { selection = queries_1.PODCAST_SELECTION; }
        return this.request((0, queries_1.createPodcastQuery)(selection), variables).then(function (data) { return data.podcast; });
    };
    PodcastFeedClient.prototype.getPodcastEpisodes = function (variables, selection) {
        if (selection === void 0) { selection = queries_1.EPISODE_SELECTION; }
        return this.request((0, queries_1.createEpisodesQuery)(selection), variables).then(function (data) { return data.episodes; });
    };
    PodcastFeedClient.prototype.getPodcastEpisode = function (variables, selection) {
        if (selection === void 0) { selection = queries_1.EPISODE_SELECTION; }
        return this.request((0, queries_1.createEpisodeQuery)(selection), variables).then(function (data) { return data.episode; });
    };
    return PodcastFeedClient;
}());
exports.default = PodcastFeedClient;
//# sourceMappingURL=PodcastFeedClient.js.map